import { render, staticRenderFns } from "./PutBackground.vue?vue&type=template&id=84a283b2&"
import script from "./PutBackground.vue?vue&type=script&lang=js&"
export * from "./PutBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports